var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full timetable-comp"},[_c('TimeTracker',{attrs:{"board_id":_vm.board_id,"currentUser":_vm.currentUser,"dragScroll":_vm.dragScroll},on:{"showUploadState":_vm.showUploadState}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }